var map = {
	"./Frame-1.svg": 6348,
	"./Frame-2.svg": 5375,
	"./Frame.svg": 3270,
	"./Group.svg": 8304,
	"./Vector 1.svg": 6131,
	"./Vector 2.svg": 5376,
	"./arrow-down.svg": 6439,
	"./arrow-mobile.svg": 1773,
	"./arrow.svg": 9646,
	"./brain.svg": 8069,
	"./burger-and-drink.svg": 2661,
	"./circle-coloured.svg": 1749,
	"./circle.svg": 3191,
	"./close-pink.svg": 7494,
	"./close-tooltips.svg": 6846,
	"./cross-coloured.svg": 1017,
	"./cross-half.svg": 5505,
	"./cross.svg": 1613,
	"./dash-coloured.svg": 8019,
	"./dash-reverse.svg": 2494,
	"./dash.svg": 6219,
	"./dna-magnify.svg": 3404,
	"./download.svg": 9983,
	"./education.svg": 4635,
	"./equality.svg": 1455,
	"./error.svg": 1719,
	"./facebook-dark.svg": 276,
	"./facebook.svg": 511,
	"./faqs.svg": 868,
	"./father-son.svg": 4294,
	"./form-loading.svg": 8202,
	"./heart.svg": 7037,
	"./home-1.svg": 9388,
	"./house.svg": 3693,
	"./instagram-dark.svg": 4030,
	"./instagram.svg": 8389,
	"./language-selector.svg": 2945,
	"./linkedin-dark.svg": 458,
	"./linkedin.svg": 1561,
	"./logo-shapes-horizontal.svg": 1882,
	"./logo.svg": 5562,
	"./lungs.svg": 8510,
	"./masthead.svg": 8230,
	"./melbuni.svg": 9923,
	"./motherhood.svg": 7796,
	"./murdoch.svg": 8159,
	"./obesity.svg": 1520,
	"./organ-health.svg": 129,
	"./pattern-grid-long.svg": 9395,
	"./pattern-grid-short.svg": 1957,
	"./pattern-grid.svg": 7640,
	"./paulramsey.svg": 2916,
	"./plus-coloured.svg": 5595,
	"./plus-half.svg": 6383,
	"./plus.svg": 1651,
	"./process1.svg": 3311,
	"./process2.svg": 4284,
	"./process3.svg": 2829,
	"./process4.svg": 8898,
	"./puzzle.svg": 7267,
	"./quote.svg": 8769,
	"./rectangle-coloured.svg": 7060,
	"./rectangle.svg": 3878,
	"./royal-childrens.svg": 5479,
	"./search.svg": 9615,
	"./sleep.svg": 3804,
	"./sneeze.svg": 1513,
	"./twitter-dark.svg": 2629,
	"./twitter.svg": 3992,
	"./vicgov.svg": 5533,
	"./youtube-dark.svg": 9975,
	"./youtube.svg": 1758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8138;